module.exports = __webpack_public_path__ + "img/forward_black.08f9ef7c.svg";